<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Tagihan External Belum Lunas</v-card-title>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.nilai_tagihan="{ item }">
          {{ formatCurrency(item.nilai_tagihan) }}
        </template>
        <template v-slot:item.tgl_jatuh_tempo="{ item }">
          <span :class="{ 'red--text': isOverdue(item.tgl_jatuh_tempo) }">
            {{ item.tgl_jatuh_tempo }}
          </span>
        </template>
      </v-data-table>

      <v-card class="mt-2 pa-3" tile v-if="data.length > 0">
        <strong>Total Belum Lunas: {{ formatCurrency(totalBelumLunas) }}</strong>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TagihanExtBelumLunas",
  data() {
    return {
      loading: {
        fetchData: false
      },
      dataHeaders: [
        { text: "Kode Vessel", value: "kv" },
        { text: "Tgl Tagihan", value: "tgl_tagihan" },
        { text: "Kategori", value: "kategori_tagihan" },
        { text: "No Tagihan", value: "no_tagihan" },
        { text: "Keterangan", value: "keterangan_tagihan" },
        { text: "Nilai", value: "nilai_tagihan" },
        { text: "Jatuh Tempo", value: "tgl_jatuh_tempo" }
      ],
      data: []
    };
  },
  computed: {
    totalBelumLunas() {
      return this.data.reduce((sum, item) => sum + (Number(item.nilai_tagihan) || 0), 0);
    }
  },
  methods: {
    formatCurrency(val) {
      if (!val) return "0";
      return Number(val).toLocaleString("id-ID");
    },
    isOverdue(date) {
      if (!date) return false;
      return new Date(date) < new Date();
    },
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`tagihan-external/belum-lunas`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
